var SubtestDetail = {
    sequence: 0,
    is_anchor: false,
    item_code: null,
    bab_code: null,
    sub_bab_code: null,
    text: "",
};

export default SubtestDetail;



// WEBPACK FOOTER //
// ./src/components/tryout/models/SubtestDetail.js